/* eslint-disable @typescript-eslint/naming-convention */
import { Dispatch } from 'react';

import { LoanTerms } from '../common/types';

export interface ABComparisonState {
  A: ComparisonCalculatorData;
  B: ComparisonCalculatorData;
  showFull: boolean;
}

export interface ComparisonCalculatorData {
  loanAmount: number;
  loanTerm: LoanTerms;
  interestRate: number;
  extraPayment: number;
}

export type CalculatorVariant = 'A' | 'B';

export enum ABComparisonDataActionsTypes {
  SET_LOAN_AMOUNT,
  SET_LOAN_TERM,
  SET_INTEREST_RATE,
  SET_EXTRA_PAYMENT,
  SET_SHOW_FULL,
  SET_DEFAULTS
}

export interface MonthlyPayment {
  annualInterestPayment: number;
  annualPrincipalPayment: number;
  balance: number;
  monthlyBreakdown: {
    monthlyPayment: number;
    principalPayment: number;
    interestPayment: number;
    balance: number;
  }[];
}

export type ABComparisonDataActions =
  | {
      type: ABComparisonDataActionsTypes.SET_LOAN_AMOUNT;
      payload: {
        value: ComparisonCalculatorData['loanAmount'];
        variant: CalculatorVariant;
      };
    }
  | {
      type: ABComparisonDataActionsTypes.SET_LOAN_TERM;
      payload: {
        value: ComparisonCalculatorData['loanTerm'];
        variant: CalculatorVariant;
      };
    }
  | {
      type: ABComparisonDataActionsTypes.SET_INTEREST_RATE;
      payload: {
        value: ComparisonCalculatorData['interestRate'];
        variant: CalculatorVariant;
      };
    }
  | {
      type: ABComparisonDataActionsTypes.SET_EXTRA_PAYMENT;
      payload: {
        value: ComparisonCalculatorData['extraPayment'];
        variant: CalculatorVariant;
      };
    }
  | {
      type: ABComparisonDataActionsTypes.SET_SHOW_FULL;
      payload: ABComparisonState['showFull'];
    }
  | {
      type: ABComparisonDataActionsTypes.SET_DEFAULTS;
    };

export type ABComparisonContextType = {
  state: ABComparisonState;
  dispatch: Dispatch<ABComparisonDataActions>;
  getMonthlyPayment: () => { A: number; B: number };
  getTotalCost: () => { A: number; B: number };
  getTotalTerm: () => { A: number; B: number };
  getPayments: () => { A: MonthlyPayment[]; B: MonthlyPayment[] } | null;
};
